module.exports = __webpack_public_path__ + "img/ring_g_o_null_1.99ec8f1e.png";